export const BASIN_TITLE = 'claim.declaration.external_damages.form.basin.material.title';
export const BASIN_MATERIAL_PLACEHOLDER = 'claim.declaration.external_damages.form.basin.material.placeholder';
